import {Directive, effect, inject, input} from '@angular/core';
import {MsTooltipDirective} from './tooltip.directive';
import {Props} from 'tippy.js';

type VaccinationTooltipType = 'date' | 'status' | 'manufacturer';

const VACCINATION_TOOLTIPS_OPTIONS: Record<VaccinationTooltipType, Partial<Props>> = {
  date: {
    placement: 'top',
    maxWidth: '150',
  },
  status: {
    placement: 'bottom',
    allowHTML: true,
    maxWidth: '270',
  },
  manufacturer: {
    placement: 'right',
  },
};

@Directive({
  selector: '[msTooltip][vaccinationsTooltipOptions]',
  standalone: true,
})
export class VaccinationsTooltipOptionsDirective {
  readonly vaccinationsTooltipOptions = input.required<VaccinationTooltipType>();

  private readonly tooltipDirective = inject(MsTooltipDirective);

  constructor() {
    this.handleTooltipOptionsChange();
  }

  private handleTooltipOptionsChange(): void {
    effect(() => {
      this.tooltipDirective.setOptionsOverride(VACCINATION_TOOLTIPS_OPTIONS[this.vaccinationsTooltipOptions()]);
    });
  }
}
